import constants from './constants.js';

const htmlSitemapGenerator = (() => {
    const supportedLocales = Object.keys(constants.defaultLocaleOptions);
    const baseDomain = window.location.origin;

    const generateHtmlSitemap = (locale) => {
        if (!supportedLocales.includes(locale)) {
            console.warn(`Unsupported locale: ${locale}`);
            return '';
        }

        const resumeSliderUrls = getSliderUrlsForLanguage(locale);
        const resumeListItems = resumeSliderUrls.map(url => {
            const fullUrl = `${baseDomain}/${locale}/resume${url}`.replace(/\/+/g, '/').replace(':/', '://');
            return `<li><a href="${fullUrl}">${fullUrl}</a></li>`;
        });

        const coverLetterSliderUrls = getSliderUrlsForLanguageCL(locale);
        const coverLetterListItems = coverLetterSliderUrls.map(url => {
            const fullUrl = `${baseDomain}/${locale}/coverletter${url}`.replace(/\/+/g, '/').replace(':/', '://');
            return `<li><a href="${fullUrl}">${fullUrl}</a></li>`;
        });

        const staticListItems = Object.entries(constants.htmlToPathMap).map(([_, path]) => {
            const localizedPath = `/${locale}/${path}`.replace(/\/+/g, '/');
            const fullUrl = `${baseDomain}${localizedPath}`;
            return `<li><a href="${fullUrl}">${fullUrl}</a></li>`;
        });

        const homeUrl = `${baseDomain}/${locale}`.replace(/\/+/g, '/');
        const homeItem = `<li><a href="${homeUrl}">${homeUrl}</a></li>`;

        return `<ul class="html-sitemap">\n${[homeItem, ...staticListItems, ...resumeListItems, ...coverLetterListItems].join('\n')
            }\n</ul>`;
    };

    const generateXmlSitemap = () => {
        const date = new Date().toISOString().split('T')[0];
        let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
        xml += `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"\n`;
        xml += `        xmlns:xhtml="http://www.w3.org/1999/xhtml">\n`;

        // ✅ Add Home URL first
        const homeCanonical = `${baseDomain}/`; // Don't modify this with .replace

        xml += `  <url>\n`;
        xml += `    <loc>${homeCanonical}</loc>\n`;
        xml += `    <lastmod>${date}</lastmod>\n`;

        constants.supportedLocales.forEach(locale => {
            const localizedPath = `/${locale}`.replace(/\/+/g, '/');
            const altUrl = `${baseDomain}${localizedPath}`;
            xml += `    <xhtml:link rel="alternate" hreflang="${locale}" href="${altUrl}" />\n`;
        });

        xml += `    <xhtml:link rel="alternate" hreflang="x-default" href="${homeCanonical}" />\n`;
        xml += `  </url>\n`;


        // 🔁 Static Pages (shared across locales)
        Object.entries(constants.htmlToPathMap).forEach(([_, path]) => {
            const cleanPath = `/${path}`.replace(/\/+/g, '/');
            const canonicalUrl = `${baseDomain}${cleanPath}`;

            xml += `  <url>\n`;
            xml += `    <loc>${canonicalUrl}</loc>\n`;
            xml += `    <lastmod>${date}</lastmod>\n`;

            constants.supportedLocales.forEach(locale => {
                const localizedPath = `/${locale}/${path}`.replace(/\/+/g, '/');
                const altUrl = `${baseDomain}${localizedPath}`;
                xml += `    <xhtml:link rel="alternate" hreflang="${locale}" href="${altUrl}" />\n`;
            });

            xml += `    <xhtml:link rel="alternate" hreflang="x-default" href="${canonicalUrl}" />\n`;
            xml += `  </url>\n`;
        });

        // 🔁 Resume and Cover Letter Templates (locale-specific only)
        constants.supportedLocales.forEach(locale => {
            const resumeTemplates = getSliderUrlsForLanguage(locale) || [];
            resumeTemplates.forEach(path => {
                const full = `${baseDomain}/${locale}/resume${path}`;
                xml += `  <url>\n    <loc>${full}</loc>\n    <lastmod>${date}</lastmod>\n  </url>\n`;
            });

            const coverTemplates = getSliderUrlsForLanguageCL(locale) || [];
            coverTemplates.forEach(path => {
                const full = `${baseDomain}/${locale}/coverletter${path}`;
                xml += `  <url>\n    <loc>${full}</loc>\n    <lastmod>${date}</lastmod>\n  </url>\n`;
            });
        });

        xml += `</urlset>`;
        return xml;
    };



    const init = (locale) => {
        const container = document.getElementById('sitemap-inline');
        if (!container) {
            console.warn(`#sitemap-inline not found`);
            return;
        }

        if (locale) {
            const sitemapHtml = generateHtmlSitemap(locale);
            container.innerHTML = sitemapHtml;
        } else {
            const sitemapXml = generateXmlSitemap();

            // Display XML as plain text for debug or admin view
            const pre = document.createElement('pre');
            pre.textContent = sitemapXml;
            container.innerHTML = '';
            container.appendChild(pre);

            // Create downloadable blob and link
            const blob = new Blob([sitemapXml], { type: 'application/xml' });
            const url = URL.createObjectURL(blob);

            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = 'sitemap.xml';
            downloadLink.textContent = 'Download sitemap.xml';
            downloadLink.style.display = 'inline-block';
            downloadLink.style.marginTop = '1rem';

            container.appendChild(downloadLink);
        }
    };



    return {
        init,
        generateHtmlSitemap,
        generateXmlSitemap,
    };
})();

export default htmlSitemapGenerator;
